import { render, staticRenderFns } from "./DashboardIcon.vue?vue&type=template&id=5ff7c958&"
import script from "./DashboardIcon.vue?vue&type=script&lang=js&"
export * from "./DashboardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff7c958')) {
      api.createRecord('5ff7c958', component.options)
    } else {
      api.reload('5ff7c958', component.options)
    }
    module.hot.accept("./DashboardIcon.vue?vue&type=template&id=5ff7c958&", function () {
      api.rerender('5ff7c958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/components/FluentIcon/DashboardIcon.vue"
export default component.exports